import React from 'react';

/**
 * Tabla editable de días para creación manual de patrones.
 */
export function LaborPatternManualDayTable({ rows, onChange, disabled = false }) {
  const updateRow = (key, patch) => {
    onChange(rows.map((r) => (r.key === key ? { ...r, ...patch } : r)));
  };

  return (
    <div className="rounded-lg border border-gray-700 overflow-hidden">
      <div className="overflow-x-auto max-h-72 overflow-y-auto">
        <table className="w-full text-sm text-left">
          <thead className="bg-gray-900/80 text-gray-400 text-xs sticky top-0">
            <tr>
              <th className="px-2 py-2 font-medium w-8" />
              <th className="px-2 py-2 font-medium min-w-[72px]">Día</th>
              <th className="px-2 py-2 font-medium min-w-[88px]">Inicio</th>
              <th className="px-2 py-2 font-medium min-w-[88px]">Fin</th>
              <th className="px-2 py-2 font-medium min-w-[100px]">Turno</th>
              <th className="px-2 py-2 font-medium w-16">Pausa</th>
              <th className="px-2 py-2 font-medium min-w-[108px]">Minutos</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-700/80">
            {rows.map((row) => {
              const active = row.isWorkingDay;
              return (
                <tr key={row.key} className={active ? 'bg-gray-900/30' : 'bg-gray-900/10 opacity-70'}>
                  <td className="px-2 py-2 align-middle">
                    <input
                      type="checkbox"
                      checked={active}
                      onChange={(e) => updateRow(row.key, { isWorkingDay: e.target.checked })}
                      disabled={disabled}
                      className="rounded border-gray-600"
                      title="Día laborable"
                    />
                  </td>
                  <td className="px-2 py-2 align-middle text-gray-200 whitespace-nowrap">
                    {row.label}
                  </td>
                  <td className="px-2 py-1 align-middle">
                    <input
                      type="time"
                      value={row.startTime}
                      onChange={(e) => updateRow(row.key, { startTime: e.target.value })}
                      disabled={disabled || !active}
                      className="w-full bg-gray-900 border border-gray-600 text-white rounded px-1.5 py-1 text-xs"
                    />
                  </td>
                  <td className="px-2 py-1 align-middle">
                    <input
                      type="time"
                      value={row.endTime}
                      onChange={(e) => updateRow(row.key, { endTime: e.target.value })}
                      disabled={disabled || !active}
                      className="w-full bg-gray-900 border border-gray-600 text-white rounded px-1.5 py-1 text-xs"
                    />
                  </td>
                  <td className="px-2 py-1 align-middle">
                    <input
                      type="text"
                      value={row.shiftCode}
                      onChange={(e) => updateRow(row.key, { shiftCode: e.target.value })}
                      disabled={disabled || !active}
                      placeholder="Trabajo"
                      className="w-full bg-gray-900 border border-gray-600 text-white rounded px-1.5 py-1 text-xs"
                    />
                  </td>
                  <td className="px-2 py-1 align-middle">
                    <label className="inline-flex items-center gap-1 text-xs text-gray-400 cursor-pointer">
                      <input
                        type="checkbox"
                        checked={row.useBreak}
                        onChange={(e) => updateRow(row.key, { useBreak: e.target.checked })}
                        disabled={disabled || !active}
                        className="rounded border-gray-600"
                        title="Pausa"
                      />
                    </label>
                  </td>
                  <td className="px-2 py-1 align-middle">
                    {active && row.useBreak ? (
                      <div className="flex items-center gap-1">
                        <input
                          type="number"
                          min={0}
                          max={480}
                          step={5}
                          value={row.breakMinutes}
                          onChange={(e) => updateRow(row.key, { breakMinutes: Number(e.target.value) || 0 })}
                          disabled={disabled}
                          aria-label={`Pausa de ${row.label} en minutos`}
                          title="Pausa estimada en minutos"
                          className="w-16 bg-gray-900 border border-gray-600 text-white rounded px-1.5 py-1 text-xs"
                        />
                        <span className="text-gray-500 text-xs whitespace-nowrap">min</span>
                      </div>
                    ) : null}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}
